import { useEffect } from "react";

import { userManager } from "../../pages/auth/components/AzureLoginHelper";

export function Logout() {
  const doLogout = async () => {
    await userManager.signoutRedirect();
  };

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    doLogout();
  }, []);

  return (
    <div className="w-100 h-100 d-flex align-items-center justify-content-center ">
      <h1>Logging out...</h1>
    </div>
  );
}
